import { Stack, Typography } from '@mui/material'

export type BidDetailSummaryItem = Readonly<{
  label: string
  value: string
}>

export type BidDetailSummaryProps = Readonly<{
  items: ReadonlyArray<BidDetailSummaryItem>
}>

export default function BidDetailSummary({ items }: BidDetailSummaryProps) {
  return (
    <Stack direction="row" spacing={40} sx={{ px: 2, py: 2, backgroundColor: 'background.paper' }}>
      {items.map((item) => (
        <Stack key={item.label} spacing={0.5}>
          <Typography
            color="text.secondary"
            fontWeight={600}
            sx={{ textTransform: 'uppercase', letterSpacing: '0.08em' }}
            variant="caption"
          >
            {item.label}
          </Typography>
          <Typography fontWeight={600} variant="subtitle1">
            {item.value}
          </Typography>
        </Stack>
      ))}
    </Stack>
  )
}
